module.exports = require('./I18nProvider').injectI18n;
